import React from 'react';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export default function TenantNotFound() {
  const classes = useStyles();
  function handleGetUrlClick() {
    window.location.href = `${
      window.location.protocol
    }//app.${window.location.host
      .split('.')
      .slice(1)
      .join('.')}/login`;
  }

  return (
    <React.Fragment>
      <Typography variant="h1">Damstra Forms URL doesn’t exist</Typography>
      <Typography variant="body1" className={classes.bodyText}>
        Looks like you’ve entered an address that doesn’t exist.
      </Typography>
      <Typography variant="body1" className={classes.bodyText}>
        If you’re trying to log in to Damstra Forms, you can use the button
        below to get the right URL.
      </Typography>
      <div className={classes.buttonContainer}>
        <Button variant="contained" color="primary" onClick={handleGetUrlClick}>
          Get your Damstra Forms URL
        </Button>
      </div>
    </React.Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  bodyText: {
    margin: theme.spacing(3, 0),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
